var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgDeviceAndTechnologyApp(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "32px",
    height: "32px",
    viewBox: "0 0 32 32",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Basics",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Basics/Icons",
    transform: "translate(-3880.000000, -1576.000000)",
    fill: "#262626"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Device-and-technology/App",
    transform: "translate(3880.000000, 1576.000000)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M14,18 L14,32 L4,32 C1.791,32 0,30.209 0,28 L0,18 L14,18 Z M32,18 L32,28 C32,30.209 30.209,32 28,32 L18,32 L18,18 L32,18 Z M14,0 L14,14 L0,14 L0,4 C0,1.791 1.791,0 4,0 L14,0 Z M28,0 C30.209,0 32,1.791 32,4 L32,14 L18,14 L18,0 L28,0 Z",
    id: 120
  }))))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgDeviceAndTechnologyApp);
export default __webpack_public_path__ + "static/media/device-and-technology-app.2e257a17.svg";
export { ForwardRef as ReactComponent };